"use strict";

(function () {

    $.widget('khis.genericWidget', {
        options: {
            url: null,
            title: '',
            collapsible: true,
            refreshButton: false,
            refreshButtonTitle: '',
            addButton: false,
            addButtonTitle: '',
            addButtonOptionList: null,
            addButtonCallback: null,
            editButton: false,
            editButtonTitle: '',
            editButtonCallback: null
        },

        toggleLoading: function(visible){
            
            if(visible){
                this._body.hide();
                this._loading.show();
            } else {
                this._loading.hide();
                this._body.show();
            }
        },
        loadData: function(){
            this.toggleLoading(true);
            
            $.getJSON(this.options.url, {widget:this._id})
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    var w = $('#'+data.widget).data('khisGenericWidget');
                    if (data.success) {
                        w._body
                            .empty()
                            .append(data.html);
                    } else {
                        w.showErrors(xhr, status, data.error);
                    }

                    w.toggleLoading(false);
                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                });
        },
        showErrors: function(xhr, status, error){
            
            this._errors.empty();
            this._errors.append('<div class="bootstrap"><div class="control-group form-errors alert alert-error"><a class="close" data-dismiss="alert">×</a>'+error+'</div></div>');
        },

        _create: function () {
            
            this._id = this.element.attr('id');

            this.element.addClass('khis-widget');

            this.element
                .css('padding', '8px')
                .css('background-color', '#F9F9F9')
                .css('margin-bottom', '10px')
                .css('border', '1px solid #DDD');

            // Create header
            this._header = this._createHeader();

            // Create errors container
            this._errors = $('<div class="khis-widget-errors"></div>')
                .appendTo(this.element);

            // Create body
            this._body = $('<div class="khis-widget-body"></div>')
                .appendTo(this.element);

            // Create loading
            this._loading = $('<div class="khis-widget-loading" style="width: 100%; height: 100%; padding-top: 15px;" align="center"><img align="middle" style="height: 30px;" src="/assets/loading.gif"></div>')
                .appendTo(this.element);
        },
        _init: function () {
            
            if(!this._check()){
                this.toggleLoading(false);

                return false;
            }

            // Add events
            this._on({
                'refresh': function (event) {
                    this.loadData();
                }
            });

            if(this.options.collapsible){
                this._on({
                    'click .khis-widget-header .collapse_handler': function (event) {
                        var h = this._header.find('.collapse_handler');
                        h.toggleClass('ui-icon-triangle-1-n');
                        h.toggleClass('ui-icon-triangle-1-s');

                        this._body.slideToggle();
                    }
                });
            }

            // Listen to clicks on the refresh button
            this._on({
                'click .khis-widget-header .ui-icon-refresh': function (event) {
                    this.loadData();
                }
            });

            // Listen to clicks on the refresh button
            if(this.options.addButtonOptionList && this.options.addButtonOptionList.length > 0){
                this._on({
                    'click .khis-widget-header .ui-icon-plus': function (event) {
                        Popups.Multichoice.show($(event.currentTarget), this.options.addButtonOptionList, {align:'right'}, this.options.addButtonCallback);
                    }
                });
            } else if(this.options.addButtonCallback){
                this._on({
                    'click .khis-widget-header .ui-icon-plus': this.options.addButtonCallback
                });
            }

            if(this.options.editButtonCallback){
                this._on({
                    'click .khis-widget-header .ui-icon-pencil': this.options.editButtonCallback
                });
            }

            // Load data
            this.loadData();
        },
        _destroy: function () {},
        _setOption: function (key, value) {},
        _createHeader: function(){
            var _h = $('<div class="khis-widget-header" style="border-bottom: solid 2px rgb(0, 160, 175); padding: 2px; margin-bottom: 4px;"></div>');
            var _t = $('<div class="float_left"></div>');
            var _b = $('<div class="float_right"></div>');

            if(this.options.collapsible){
                _t.append('<span style="cursor: pointer; float: left;" class="ui-icon ui-icon-triangle-1-n collapse_handler"></span>');
            }

            _t.append('<span class="summary_widget_title" style="font-weight: bold;">'+this.options.title+'</span>');

            if(this.options.refreshButton){
                _b.append('<span style="cursor: pointer;" title="'+this.options.refreshButtonTitle+'" class="ui-icon ui-icon-refresh float_right"></span>');
            }

            if(this.options.addButton){
                _b.append('<span style="cursor: pointer;" title="'+this.options.addButtonTitle+'" class="ui-icon ui-icon-plus float_right"></span>');
            }

            if(this.options.editButton){
                _b.append('<span style="cursor: pointer;" title="'+this.options.editButtonTitle+'" class="ui-icon ui-icon-pencil float_right"></span>');
            }

            _h.append(_t);
            _h.append(_b);

            // Add horizontal spacer
            _h.append($('<div style="height: 1px; width: 100%; clear: both;"></div>'));

            return _h.appendTo(this.element);
        },
        _check: function(){
            if(!this.options.url){
                this.showErrors(null, null, 'Bad configuration: url not defined!');
                return false;
            }

            return true;
        }
    });

    $.widget('khis.soapWidget', $.khis.genericWidget, {
        // this ensures we keep the same namespace as the base
        widgetEventPrefix: $.khis.genericWidget.prototype.widgetEventPrefix,
        _createHeader: function(){
            var _h = $('<div class="khis-widget-header" style="border-bottom: solid 2px rgb(0, 160, 175); padding: 2px; margin-bottom: 4px;"></div>');
            var _t = $('<div class="float_left"></div>');
            var _b = $('<div class="float_right"></div>');

            if(this.options.collapsible){
                _t.append('<span style="cursor: pointer; float: left;" class="ui-icon ui-icon-triangle-1-n collapse_handler"></span>');
            }

            _t.append('<span class="summary_widget_title" style="font-weight: bold; color: rgb(0, 160, 175);">'+this.options.title[0]+'</span>');
            _t.append('<span class="summary_widget_title" style="font-weight: bold;">'+this.options.title.substr(1, this.options.title.length-1)+'</span>');

            if(this.options.refreshButton){
                _b.append('<span style="cursor: pointer;" title="'+this.options.refreshButtonTitle+'" class="ui-icon ui-icon-refresh float_right"></span>');
            }

            if(this.options.addButton){
                _b.append('<span style="cursor: pointer;" title="'+this.options.addButtonTitle+'" class="ui-icon ui-icon-plus float_right"></span>');
            }

            //_h.append('<span style="cursor: pointer;" title="Editar" class="ui-icon ui-icon-pencil float_right"></span>');

            _h.append(_t);
            _h.append(_b);

            // Add horizontal spacer
            _h.append($('<div style="height: 1px; width: 100%; clear: both;"></div>'));

            return _h.appendTo(this.element);
        },
        loadData: function(){
            this.toggleLoading(true);

            $.getJSON(this.options.url, {widget:this._id})
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    var w = $('#'+data.widget).data('khisSoapWidget');
                    if (data.success) {
                        w._body
                            .empty()
                            .append(data.html);
                    } else {
                        w.showErrors(xhr, status, data.error);
                    }

                    w.toggleLoading(false);
                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                });
        }
    });


    $.widget('khis.OccupationalMedicineWidget', $.khis.genericWidget, {
        // this ensures we keep the same namespace as the base
        widgetEventPrefix: $.khis.genericWidget.prototype.widgetEventPrefix,
        loadData: function(){
            this.toggleLoading(true);

            $.getJSON(this.options.url, {widget:this._id})
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    var w = $('#'+data.widget).data('khis-OccupationalMedicineWidget');
                    if (data.success) {
                        w._body
                            .empty()
                            .append(data.html);

                        // Update buttons
                        if(data.add_enabled == true){
                            w._header.find('span.ui-icon-plus').show();
                        } else if(data.add_enabled == false){
                            w._header.find('span.ui-icon-plus').hide();
                        }

                        if(data.edit_enabled == true){
                            w._header.find('span.ui-icon-pencil').show();
                        } else if(data.edit_enabled == false){
                            w._header.find('span.ui-icon-pencil').hide();
                        }
                    } else {
                        w.showErrors(xhr, status, data.error);
                    }

                    w.toggleLoading(false);
                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                });
        }
    });

})();


